import { Injectable } from '@angular/core';

import {
  catchError, map, Observable, of
} from 'rxjs';

import { ConfigurationService } from '@sondermind/configuration';
import { HttpService } from '@sondermind/http';

@Injectable({ providedIn: 'root' })
export class PhoneValidatorHttpService {
  constructor(
    private configurationService: ConfigurationService,
    private http: HttpService
  ) {}

  getIsPhoneNumberValid(phoneNumber: string): Observable<boolean> {
    // This endpoint returns an empty 200 code if the phone number is valid,
    // and a 400 error message if it's invalid.
    return this.http.post(
      `${this.configurationService.env.svcBase}/referrals/referral_requests/validate_attributes`,
      {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        phone_number: phoneNumber
      }
    ).pipe(
      map(() => true),
      catchError(() => of(false))
    );
  }
}
